(() => {
  'use strict';
  if (window.cofcofNarrative30) return;
  const instances = new Map();
  function mount(root = document) {
    root.querySelectorAll('[data-cofcof-story]').forEach((section) => {
      if (instances.has(section)) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const button = section.querySelector('[data-story-replay]');
      let visible = !('IntersectionObserver' in window);
      let played = false;
      let playing = false;
      const sync = () => {
        if (reduced.matches) {
          playing = false;
          section.classList.remove('is-story-playing');
        } else if (visible && !document.hidden && !played) {
          played = true;
          playing = true;
          section.classList.add('is-story-playing');
        }
        section.classList.toggle('is-story-paused', !visible || document.hidden);
        if (button) {
          button.hidden = reduced.matches;
          button.disabled = playing;
        }
      };
      const finished = (event) => {
        if (event.animationName?.startsWith('cofcof-story-')) {
          playing = false;
          if (button) button.disabled = false;
        }
      };
      const replay = () => {
        if (reduced.matches || playing) return;
        section.classList.remove('is-story-playing');
        void section.offsetWidth;
        played = false;
        sync();
      };
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
        sync();
      }, { threshold: .15 }) : null;
      observer?.observe(section);
      section.addEventListener('animationend', finished);
      button?.addEventListener('click', replay);
      reduced.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
      sync();
      instances.set(section, () => {
        observer?.disconnect();
        section.removeEventListener('animationend', finished);
        button?.removeEventListener('click', replay);
        reduced.removeEventListener('change', sync);
        document.removeEventListener('visibilitychange', sync);
        instances.delete(section);
      });
    });
  }
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((destroy, section) => { if (event.target.contains(section)) destroy(); });
  });
  window.cofcofNarrative30 = { mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
})();
